(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6450],{

/***/ 68113:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/mileage-calculator",
      function () {
        return __webpack_require__(1513);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CalculatorBlogs_Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./components/CalculatorBlogs/BlogCard.jsx




const BlogCard = (param)=>{
    let { question , answer  } = param;
    const [blogVisible, setBlogVisible] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex mb-[30px] pb-[30px] gap-[20px] border-b border-b-gray-300",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>blogVisible ? setBlogVisible(false) : setBlogVisible(true),
                className: "pt-[5px] text-[20px] md:text-[35px] w-fit cursor-pointer",
                children: blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineMinus */.ywL, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "question text-[25px] md:text-[30px] mb-[20px] font-medium",
                        children: question
                    }),
                    blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "answer text-[16px] md:text-[18px] font-light text-gray-700",
                        children: answer
                    }) : ""
                ]
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/CalculatorBlogs/Blog.jsx



const Blog = (param)=>{
    let { heading , BlogData , width ="lg:w-[850px]"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[100%] mx-auto md:w-[80%] ".concat(width),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[25px] md:text-[40px] text-center font-bold mb-14 mx-auto",
                children: heading
            }),
            BlogData.map((blog)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorBlogs_BlogCard, {
                    question: blog.question,
                    answer: blog.answer
                }, blog.id);
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_Blog = (Blog);


/***/ }),

/***/ 1513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ mileage_calculator; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/Tools/MileageCalculator/MileageCalc.jsx


const MileageCalc = ()=>{
    const [inputData, setInputData] = (0,react.useState)({
        distance: "360",
        fuelConsumed: "7",
        fuelType: "Litre",
        fuelCost: "76.34",
        currency: "USD"
    });
    const [resultData, setResultData] = (0,react.useState)({
        mileage: "51.43",
        distance: "360",
        fuelType: "Litre",
        totalAmount: "534.38",
        currency: "USD"
    });
    const calculateMileage = (0,react.useCallback)(()=>{
        const { distance , fuelConsumed , fuelType , fuelCost , currency  } = inputData;
        if (distance && fuelConsumed && fuelCost) {
            const mileage = (distance / fuelConsumed).toFixed(2);
            const totalAmount = (fuelCost * fuelConsumed).toFixed(2);
            setResultData((prev)=>({
                    ...prev,
                    mileage,
                    distance,
                    fuelType,
                    totalAmount,
                    currency
                }));
        }
    }, [
        inputData
    ]);
    (0,react.useEffect)(()=>{
        calculateMileage();
    }, [
        calculateMileage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full max-w-[1000px] bg-gray-100 mx-auto py-[30px] md:px-[30px] rounded-sm drop-shadow-lg flex flex-col lg:flex-row gap-[20px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-w-[100%] lg:w-[50%] h-full bg-white p-[10px] md:p-[20px] py-[30px] md:py-[30px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-gray-500 flex flex-col gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-gray-700 font-medium text-[18px] border-b-2 pb-[15px] mb-[10px]",
                                children: "Mileage By Distance Travelled"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-gray-500 font-medium text-[16px]",
                                        children: "Distance Travelled"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]",
                                        id: "",
                                        name: "",
                                        type: "text",
                                        placeholder: "250 Km",
                                        required: true,
                                        value: inputData.distance,
                                        onChange: (e)=>setInputData((prev)=>({
                                                    ...prev,
                                                    distance: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-gray-500 font-medium text-[16px]",
                                        children: "Fuel Consumed"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]",
                                        id: "",
                                        name: "",
                                        type: "text",
                                        placeholder: "7 Litre/Gallon",
                                        required: true,
                                        value: inputData.fuelConsumed,
                                        onChange: (e)=>setInputData((prev)=>({
                                                    ...prev,
                                                    fuelConsumed: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex gap-[20px] w-[180px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center gap-[5px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        onChange: (e)=>setInputData((prev)=>({
                                                                    ...prev,
                                                                    fuelType: e.target.value
                                                                })),
                                                        id: "fuel-1",
                                                        type: "radio",
                                                        name: "fuel",
                                                        value: "Litre",
                                                        checked: inputData.fuelType === "Litre",
                                                        className: "h-4 w-4 border-gray-300 focus:ring-2 focus:ring-blue-300"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: "fuel-1",
                                                        className: "text-[16px] text-gray-500",
                                                        children: "Litre"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center gap-[5px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        onChange: (e)=>setInputData((prev)=>({
                                                                    ...prev,
                                                                    fuelType: e.target.value
                                                                })),
                                                        id: "fuel-2",
                                                        type: "radio",
                                                        name: "fuel",
                                                        value: "Gallon",
                                                        checked: inputData.fuelType === "Gallon",
                                                        className: "h-4 w-4 border-gray-300 focus:ring-2 focus:ring-blue-300"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: "fuel-2",
                                                        className: "text-[16px] text-gray-500",
                                                        children: "Gallon"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-gray-500 font-medium text-[16px]",
                                        children: "Cost/Unit Fuel"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]",
                                        id: "",
                                        name: "",
                                        type: "text",
                                        placeholder: "$34",
                                        required: true,
                                        value: inputData.fuelCost,
                                        onChange: (e)=>setInputData((prev)=>({
                                                    ...prev,
                                                    fuelCost: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-gray-500 font-medium text-[16px]",
                                        children: "Currency"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                            className: "border outline-none rounded-md w-[180px] h-[50px]",
                                            id: "",
                                            name: "",
                                            required: true,
                                            value: inputData.currency,
                                            onChange: (e)=>setInputData((prev)=>({
                                                        ...prev,
                                                        currency: e.target.value
                                                    })),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "USD",
                                                    children: "US Dollar"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "INR",
                                                    children: "Indian Rupee"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: ()=>calculateMileage(),
                                className: "w-full h-[50px] mt-[20px] bg-violet-500 hover:opacity-75 text-white font-medium text-[18px] rounded-lg shadow-2xl",
                                children: "Calculate"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-[100%] lg:w-[50%] h-full flex flex-col gap-[20px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-white py-[2px] mb-[10px] h-[50px] flex items-center text-center justify-center px-[10px] font-medium text-[25px] bg-violet-500",
                        children: "Result"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col justify-center items-center bg-gray-200 w-fit mx-auto p-[30px] rounded-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-[20px] font-medium text-gray-500",
                                children: "Mileage"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[60px] font-bold text-gray-700",
                                children: resultData.mileage
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: "text-gray-500",
                                children: [
                                    "Km/",
                                    resultData.fuelType
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full text-gray-500 font-medium flex flex-col gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " flex items-center gap-[30px] justify-around text-[20px] mx-[15px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[50%] text-center border-b-[1px] border-b-gray-400 pb-[5px] px-[5px]",
                                        children: "Units"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[50%] text-center border-b-[1px] border-b-gray-400 pb-[5px] px-[5px]",
                                        children: "Output"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " flex items-center justify-around text-[18px] text-gray-400",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[50%] text-center",
                                        children: "Distance"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-[50%] text-center",
                                        children: [
                                            resultData.distance,
                                            " Km"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " flex items-center justify-around text-[18px] text-gray-400",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[50%] text-center",
                                        children: "Fuel"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[50%] text-center",
                                        children: resultData.fuelType
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " flex items-center justify-around text-[18px] text-gray-400",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[50%] text-center",
                                        children: "Total Amount"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-[50%] text-center",
                                        children: [
                                            resultData.totalAmount + " " + resultData.currency,
                                            " "
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var MileageCalculator_MileageCalc = (MileageCalc);

// EXTERNAL MODULE: ./components/CalculatorBlogs/Blog.jsx + 1 modules
var Blog = __webpack_require__(56130);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/calculators/mileage-calculator/index.jsx





const BlogData = [
    {
        id: 1,
        question: "How can I use the Mileage Calculator tool to track my fuel costs?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Our Mileage Calculator tool can help you keep track of your fuel costs by calculating the total cost of used fuel based on the fuel prices. It allows you to input the distance traveled, fuel required, and the cost of fuel. You can also calculate the mileage of your vehicle based on the fuel used and distance travelled."
            })
        })
    },
    {
        id: 2,
        question: "How can the Mileage Calculator tool help me optimise my travel expenses?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "By providing accurate information about fuel requirements and costs, the Mileage Calculator tool helps you plan your travel expenses and optimise them accordingly. With this tool, you can also calculate the fuel economy of your vehicle and plan your trip accordingly."
            })
        })
    },
    {
        id: 3,
        question: "Can the Mileage Calculator tool be used to calculate fuel economy?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Yes, the Mileage Calculator tool can be used to calculate the fuel economy of your vehicle based on the fuel used and distance travelled. It is an essential tool for anyone who wants to keep track of their fuel usage and optimise their travel expenses."
            })
        })
    },
    {
        id: 4,
        question: "Is the Mileage Calculator tool easy to use?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Yes, our Mileage Calculator tool is very user-friendly and easy to use. Simply input the required information such as distance travelled, fuel required, and the cost of fuel, and the tool will do the rest."
            })
        })
    },
    {
        id: 5,
        question: "Can I save my calculations for future reference?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Yes, the Mileage Calculator tool allows you to save your calculations for future reference. This feature is useful for those who want to keep track of their travel expenses over time."
            })
        })
    },
    {
        id: 6,
        question: "Can the Mileage Calculator tool be used as a fuel cost calculator?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Yes, the Mileage Calculator tool can be used as a fuel cost calculator. It allows you to calculate the total cost of used fuel based on fuel prices, as well as the total fuel used, vehicle mileage, total fuel price, and price for one mile."
            })
        })
    },
    {
        id: 7,
        question: "How can the Mileage Calculator tool save me money on my next trip?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "By providing accurate information about fuel requirements and costs, the Mileage Calculator tool can help you plan your trip more efficiently and save money on fuel expenses. It also allows you to optimise your travel expenses by providing information on fuel economy, total fuel used, and more."
            })
        })
    }
];
const MileageCalculator = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container mx-auto w-full px-[10px] lg:px-[100px] py-[20px] sm:py-[100px] flex flex-col items-center justify-between gap-[50px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Mileage Calculator | Calculators | BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "publisher",
                        content: "BoloSign "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/calculators/mileage-calculator/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/calculators/mileage-calculator/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Mileage Calculator | Calculators | BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/calculators/mileage-calculator/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 z-[-500] left-0 w-full bg-violet-500 h-[500px]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-[15px] sm:gap-[30px] w-full xl:w-[80%] text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "font-bold text-[45px] xl:text-[60px] leading-[45px] xl:leading-[60px] text-white",
                        children: "Mileage Calculator"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-white text-[16px] lg:text-[18px] font-light",
                        children: "Track your fuel costs and optimize your travel expenses with our free Mileage Calculator tool. Calculate fuel requirements, costs, and economy based on your vehicle‘s mileage and distance traveled. Our Mileage Calculator doubles as a fuel cost calculator, allowing you to calculate the total cost of used fuel based on fuel prices. Additionally, you can save your calculations for future reference. Try our Mileage Calculator today and save money on your next trip!"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MileageCalculator_MileageCalc, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog/* default */.Z, {
                heading: "Mileage Calculator FAQs",
                BlogData: BlogData
            })
        ]
    });
};
/* harmony default export */ var mileage_calculator = (MileageCalculator);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,9774,2888,179], function() { return __webpack_exec__(68113); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);